module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGdc5e37ffc31f35a95f7afd69214f85a2.dc5e37ff.png";